module.exports = __webpack_public_path__ + "img/search-medium.d48c244c.svg";